module.exports = __webpack_public_path__ + "static/media/uncheck-lesson.cdd231ad.svg";